import { FC } from "react";
import { Trans } from "react-i18next";

import { UserRole } from "types/BETypes";
import { UserRoleLabel } from "components/UserRoleLabel";

import { Text } from "uikit";
import { Badge } from "uikit/Badge";

import { UserCompanyResDto } from "utils/swagger_react_query";

import {
  ArrowIcon,
  Container,
  InnerLeftContainer,
  InnerRightContainer,
  UserRolesContainer,
} from "./styles";

interface IProps {
  data: UserCompanyResDto;
  onClick: () => void;
  dataTestId: string;
}

export const CompanyListItem: FC<IProps> = ({ data, onClick, dataTestId }) => {
  const translationPrefix = `auth_pages.shared.select_company_page`;
  const shouldShowAcceptInvitationBadge = !data.hasSignedIn;

  return (
    <Container onClick={onClick} data-testid={dataTestId}>
      <InnerLeftContainer>
        <Text $fs="t14">{data.name}</Text>

        {shouldShowAcceptInvitationBadge && (
          <Badge $variant="yellow" $ml={"8px"}>
            <Trans i18nKey={`${translationPrefix}.companies_list.accept_invitation_badge`} />
          </Badge>
        )}
      </InnerLeftContainer>

      <InnerRightContainer>
        <UserRolesContainer>
          {data.companyRoles.map((role) => (
            <UserRoleLabel key={`${data.companyId}-${role}`} userRole={role as UserRole} />
          ))}
        </UserRolesContainer>

        <ArrowIcon />
      </InnerRightContainer>
    </Container>
  );
};
